import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';

import {HttpClient, HttpParams} from '@angular/common/http';
import {DaoGeneric} from '@Services/base/daoService';
import {ListReference} from '../index';
import {Observable, of} from 'rxjs';
import {CodesAnalytiquesModel} from './codes-analytiques.model';


@Injectable({   providedIn: 'root' })
export class CodesAnalytiquesService extends DaoGeneric<CodesAnalytiquesModel> {
  private url = `${environment.baseUrl}/dar/codeanalytiques/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  /**
   * Liste des codes analytiques
   */
  listCodesAnalytiques(): Observable<ListReference[]> {
    return of([
      { id: 1, label: 'label_1' },
      { id: 2, label: 'label_2' }
    ]);
  }

  getBase(): Observable<CodesAnalytiquesModel[]> {
    return this.httpClient.get<CodesAnalytiquesModel[]>(`${this.url}getBase/`);
  }

  getByParent(can_parent: string): Observable<CodesAnalytiquesModel[]> {
    const params = new HttpParams()
      .set('can_parent', can_parent);
    return this.httpClient.get<CodesAnalytiquesModel[]>(`${this.url}getByParent/`, {params});
  }
}
